import styled from 'styled-components';
import { propStyles } from '../styleHelper';

const TableHeaderCell = styled.th`
  text-align: left;
  padding: ${props => props.theme.padding.normal};
  border-left: solid 1px ${props => props.theme.border.border300};
  &:first-child {
    border: none;
  }
  ${propStyles}
`;

export default TableHeaderCell;
